/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'
import VueCookie from 'vue-cookie'

import routes from './routes'
// import Roles from '@/utils/role'
import { UserService } from '@/services/user.service'
import { TokenService } from '../services/storage.service'
import { isAdmin, checkRoutePermission } from '@/utils/helper' 

import { abilitiesPlugin } from '@casl/vue'

import { setUserAAuthorization } from '@/utils/ability'

import ApiService from '../services/api.service'

import store from '@/store'

Vue.use(VueCookie)
var Cookie = Vue.cookie

Vue.use(Router)
// Create a new router
const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

router.beforeEach((to, from, next) => {
  let user = TokenService.getCurrentUser()
  let token = TokenService.getToken()
  let refreshToken = TokenService.getRefreshToken()

  if (token && TokenService.isTokenExpired()) {
    console.log('no token or token has expired')
    TokenService.purge()
    UserService.SSOLogin()
  } else {

    if (store.state.currentUser.isLoggedIn) {
      let ability = setUserAAuthorization(store.state.currentUser)
      Vue.use(abilitiesPlugin, ability)
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!token && !to.query.code) {
        UserService.SSOLogin()
      } else if ( to.query.code) {
        UserService.authorize(to.query.code)
      } else {
        let currentUser = TokenService.getCurrentUser()
        if (!currentUser) {
          UserService.SSOLogin()
        }
  
        if (user.groups.length) {
          if (to.meta.permission === 'public' || checkRoutePermission(to.path)) {
            next()
          } else if (to.meta.error || to.fullPath === '/') {
            next()
          } else {
            next({
              path: '/403',
              params: { nextUrl: to.fullPath }
            })
          }
        }
      }
    } else {
      next({ path: '/404' })
    }
  }
})

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
